import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";
import RiskMembersModule from "./RiskMembers/index";
import FreezeLifecycleModule from "./freezeLifecycle/index";
import NumberOfActiveMembersByModule from "./numberOfActiveMembersBy/index";
import MembershipBreakdownModule from "./membershipBreakdownChart/index";
import ZeroVisitMembersModule from "./ZeroVisitMembersChart/index";
import HeatmapModule from "./heatmap/index";
import AttritionAndCancelReasonsModule from "./attritionAndCancelReasons/index";
import MemberVisitsModule from "./memberVisits";
import ActivePackagesModule from "./activePackages";
import AIAgent from "../ai";

const pageConfig = {
  pageName: "Memberships",
  configuratorWidth: { dark: 470, light: 400 },
  moduleList: [
    NumberOfActiveMembersByModule,
    RiskMembersModule,
    FreezeLifecycleModule,
    MembershipBreakdownModule,
    ZeroVisitMembersModule,
    HeatmapModule,
    AttritionAndCancelReasonsModule,
    MemberVisitsModule,
    ActivePackagesModule
  ]
};

const MembershipPage = ({ notifications, objectId }) => {
  return (
    <PageWithConfigurator
      pageConfig={pageConfig}
      notifications={notifications}
      renderAI={() => <AIAgent pageName="membership" widget objectId={objectId} />}
    />
  );
};

export default MembershipPage;
